import { RefreshCw } from 'lucide-react';
import { useEffect, useState } from 'react';
import { isNativeApp } from '../lib/api';
import { useCart } from '../lib/cart';
import { tr } from '../lib/i18n';

const scriptOf = (html: string) => /<script[^>]+src="([^"]*\/assets\/[^"]+)"/.exec(html)?.[1] ?? null;

/**
 * After a new deploy, offer a reload instead of forcing one, so a sale in progress is never lost.
 * Checks the published index.html every 30 minutes (one small request).
 */
export function UpdatePrompt() {
  const [ready, setReady] = useState(false);
  const busy = useCart((s) => s.lines.length > 0);
  useEffect(() => {
    if (!import.meta.env.PROD || isNativeApp()) return;
    const current = scriptOf(document.documentElement.outerHTML);
    const check = async () => {
      try {
        const html = await (await fetch('/index.html', { cache: 'no-store' })).text();
        const latest = scriptOf(html);
        if (current && latest && latest !== current) setReady(true);
      } catch { /* offline: try later */ }
    };
    const t = setInterval(() => void check(), 30 * 60_000);
    return () => clearInterval(t);
  }, []);
  if (!ready) return null;
  return (
    <div role="status" className="fixed inset-x-3 bottom-24 z-40 mx-auto flex max-w-md items-center gap-3 rounded-full bg-forest-800 py-2 pr-2 pl-4 text-sm font-bold text-white shadow-lift lg:bottom-4">
      <RefreshCw size={16} /><span className="flex-1">{busy ? tr('A new version is ready — reload after this bill') : tr('A new version of Sense Daily is ready')}</span>
      <button disabled={busy} onClick={() => location.reload()} className="rounded-full bg-white px-4 py-1.5 text-primary disabled:opacity-50">{tr('Reload')}</button>
    </div>
  );
}
